import { PageTypePortal } from "@/lib/types";

/** Query param on class registration page for deep-linking from public class page. */
export const CLASS_REGISTRATION_CLASS_ID_PARAM = "classId";

export function buildClassRegistrationPath(classId: number): string {
  const base = PageTypePortal.ClassRegistration;
  if (!classId || classId <= 0) return base;
  return `${base}?${CLASS_REGISTRATION_CLASS_ID_PARAM}=${encodeURIComponent(String(classId))}`;
}

export function appendCallbackUrl(path: string, callbackUrl: string): string {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}callbackUrl=${encodeURIComponent(callbackUrl)}`;
}

export function buildClassRegistrationSignInUrl(classId: number): string {
  const callback = buildClassRegistrationPath(classId);
  return appendCallbackUrl(PageTypePortal.Login, callback);
}

export function buildClassRegistrationSignUpUrl(classId: number): string {
  const callback = buildClassRegistrationPath(classId);
  return appendCallbackUrl(PageTypePortal.SignUp, callback);
}

export function parseClassIdFromRegistrationPath(pathOrUrl: string): number | null {
  try {
    const query = pathOrUrl.includes("?")
      ? pathOrUrl.slice(pathOrUrl.indexOf("?"))
      : "";
    const params = new URLSearchParams(
      query.startsWith("?") ? query.slice(1) : query,
    );
    const raw = params.get(CLASS_REGISTRATION_CLASS_ID_PARAM);
    if (!raw) return null;
    const n = Number(raw);
    if (Number.isNaN(n) || n <= 0) return null;
    return n;
  } catch {
    return null;
  }
}
